import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 sm:px-0 py-16  w-full rounded items-center text-gray-500 flex-col flex mt-12 space-y-2" }
const _hoisted_2 = { class: "text-2xl text-gray-600" }
const _hoisted_3 = { class: "text-base" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("main", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent()), { class: "w-24 h-24" })),
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1)
  ]))
}